
import { defineComponent } from 'vue';

import { Step } from '@/components/wizard';
import Radio from '@/components/Radio.vue';
import { HealthState, useCalculationState } from '@/lib/calculationstate';

import Navigation from '@/components/wizard/Navigation.vue';

export default defineComponent({
  name: 'Situation',
  components: { Radio, Step, Navigation },
  props: {
    step: { type: Number, required: true },
  },
  data() {
    return {
      HealthState,
    };
  },
  setup() {
    const state = useCalculationState();
    return {
      state,
    };
  },
});
